import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./styles/color.css";
import "./styles/font.css";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";
import "./styles/tailwind.css";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { HeroUIProvider } from "@heroui/react";
import { I18nProvider } from "@react-aria/i18n";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <I18nProvider locale="en-GB">
        <HeroUIProvider locale="en-GB">
          <App />
          <ToastContainer />
        </HeroUIProvider>
      </I18nProvider>
    </BrowserRouter>
  </QueryClientProvider>
);

/*ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <BrowserRouter>
      <App />
      <ToastContainer />
    </BrowserRouter>
  </QueryClientProvider>,
  document.getElementById("root")
);*/
